import { Map } from 'immutable';
import Actions from 'flow/actions';

//SET_OMNICHANNEL_VALUE
const initialState = Map({
    deepLinkId: undefined,
    userOwnedErrandsAwaitingActivityCount: 0,
    deeplinkPerCallerId: Map(),
});

export const omnichannelReducer = (state = initialState, action) => {
    switch (action && action.type) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.SET_OMNICHANNEL_DEEPLINK_ID: {
            return state.set('deepLinkId', action.deepLinkId);
        }
        case Actions.SET_USER_OWNED_OMNICHANNEL_ERRANDS_AWAITING_ACTIVITY_COUNT: {
            return state.set(
                'userOwnedErrandsAwaitingActivityCount',
                action.errandsCount,
            );
        }
        case Actions.SET_OMNICHANNEL_IFRAME_REF: {
            return state.set('iframeRef', action.iframeRef);
        }
        case Actions.SET_CENTION_DEEPLINK_FOR_CALLER_ID: {
            return state.setIn(
                ['deeplinkPerCallerId', action.callerId],
                action.deeplink,
            );
        }
        case Actions.REMOVE_CENTION_DEEPLINK_FOR_CALLER_ID: {
            return state.deleteIn(['deeplinkPerCallerId', action.callerId]);
        }
        default: {
            return state;
        }
    }
};

export default omnichannelReducer;
